import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form, FormControl } from 'react-bootstrap';
import env from '../ENV';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal_forDispatch';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    if (month.length < 2) 
    month = '0' + month;
    if (day.length < 2) 
    day = '0' + day;
    return [day, month, year].join('-');
  }
  
  class DispatchArrangePoitem extends React.Component {

    constructor(props) {
        super(props);
        this.state={
        PONumber: this.props.location.state.PONumber,
        allChecked: false,
        supplierName: "ABC Tech Inc.",
        select: true,
        checkbox:false,
        open: false,
        checked: [],
        opacity:"",
        comments:'',
        formattedData: [],
        selectAll: false,
        modal: false,
        lorryreceiptmodal:false,
        multiCollapseIndex:"",
        array2: [
            {  value: 1, id:1, PoNo: "4700026943", PoName: "ABC" , PoItem: "11" , PoDate: "12-06-2020" , status: "Transporter has been assigned", WBSNo: "A0XXXX", totalPoQuantity: "50" , quantityToDispatch: "" , itemDescription: "STAND TILTING DEVICE" , dispatchConditions: "DAP", arrangeTransport: "SMS", proposedDate: "" },
            {  value: 2, id:2, PoNo: "4700026943", PoName: "ABC" , PoItem: "13" , PoDate: "11-01-2020" , status: "Transporter has been assigned", WBSNo: "A0XXX0", totalPoQuantity: "90" , quantityToDispatch: "" , itemDescription: "TRANSFER DEVICE, CROSS" , dispatchConditions: "EXW", arrangeTransport: "Supplier", proposedDate:  ""},
            
        ]       
      }
      // this.dateformate = this.dateformate.bind(this);
     
      this.comments = this.comments.bind(this);
      this.togglebutton = this.togglebutton.bind(this); 
      this.handleChange = this.handleChange.bind(this);
      this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
      
    
    }

  



    action1() {
             this.setState({ action1: false });
             } 

    togglebutton=(Index)=> {  
      
      var multiCollapseIndex = this.state.multiCollapseIndex
  
      if(multiCollapseIndex!=Index || multiCollapseIndex==''){
        this.setState({multiCollapseIndex:Index})
    }}

    handleChange = () => {   
      var selectAll = !this.state.selectAll;
      this.setState({ selectAll: selectAll });
      var checkedCopy = [];
      this.state.array2.map(function(e, index) {
        checkedCopy.push(selectAll);
      });
      this.setState({
        checked: checkedCopy
      });
    };

    handleSingleCheckboxChange = index => {
      console.log(index);
      var checkedCopy = this.state.checked;
      checkedCopy[index] = !this.state.checked[index];
      if (checkedCopy[index] === false) {
        this.setState({ selectAll: false });
      }
      this.setState({
        checked: checkedCopy
      });
    };

   
    toggleSuccessModal(e){
      this.setState({ modal: !this.state.modal });
      if(this.state.modal ==true){
        this.setState(
      {opacity:""}
        )}
    else{
        this.setState(
           {opacity:"0.2"} 
        ) }
      }

      comments(event) { 
        this.setState({comments: event.target.value})
        // console.log(this.state.comments,"comments") ;
       }


      handleClick = () => {
        var datePattern= document.getElementById('myDate').value;
        document.getElementById("demo").innerHTML=datePattern;
      }
      

    render()
    {
        return(
                        
            <div className="Container-fluid pageheight"  >
               
               <div className="Container-fluid p-4" >

                <div className="row pr-4" >
                    <div className="col-md-8 header ">
                  </div>
                    
                    <div className="col pt-2  xs={last}">
                    <SearchBar placeholder="Search"  label="Search"  btnName=""  />
                    </div>
                </div>
                
              <div className="row-md-8 pr-4">
                <div className="col ">
                    <div className="row  headerbar ">
                   
                          
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Number</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Item</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Date</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Status </div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar">Action </div>
                    </div>

                        {this.state.array2.map((element,Index)=>
                            <div className={Index%2==0? 'row border ':'row  background '} 
                             onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                             
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{this.state.PONumber}</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{element.PoItem}</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar ">{dateFormater(element.PoDate)}</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">{element.status}</div>
                            <div className="col-md-2 pt-2 pb-2borderheaderbar amount-text headeralign">
                              <Link  to ={{ pathname: '/DispatchDocumentsDashboard',state : { PONumber: element.PoNo , PoItem:element.PoItem,WBSNo:element.WBSNo } }}>
                                <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg"  />
                              </Link>
                             </div> 
                           
                            
                      
                         <div className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                                  <form>
                                        <div></div>
                                           <div className="row">
                                              <div className="col-md-3">
                                                  <b>WBS No: </b>
                                               </div>
                                               <div className="col">
                                                {element.WBSNo}
                                                </div>
                                                
                                               <div className="col-md-3">
                                                 <b>Total PO Quantity: </b>
                                               </div>
                                               <div className="col">
                                                {element.totalPoQuantity}
                                               </div>
                                            </div>
                                            <br />
                                            
                                            <br />
                                           
                                                <br />

                                              
                                              <br />
                                   </form> 
                             </div>
                          </div>
                    )}  
                        <br/> 
                        <br/>        
                  
                  </div>
            </div>
        </div>
      </div>
    )
  }
}

export default DispatchArrangePoitem;